export enum MfaMethod {
  MFA_METHOD_UNKNOWN = 'MFA_METHOD_UNKNOWN',
  EMAIL_ADDRESS = 'EMAIL_ADDRESS',
  SMS = 'SMS',
  PHONE_CALL = 'PHONE_CALL',
}
